/* istanbul ignore file: Directive */
'use strict';

customerZone

    .config(['vcRecaptchaServiceProvider', 'configProvider', function(vcRecaptchaServiceProvider, configProvider){
        var config = configProvider.$get();
        vcRecaptchaServiceProvider.setSiteKey(config.recaptchaKey);
        vcRecaptchaServiceProvider.setLang(config.language === 'fr_BE' ? 'fr' : 'nl');
    }]);
